import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { PageSectionTwoColumnsImageFullwidth } from 'components/page/sections/page-section-two-columns-image-fullwidth';
import { SectionContentLinkList } from 'components/section-content-link-list';
import { SectionContentLinkListIdThree } from 'components/section-content-link-list/section-content-link-list.enums';

export const TabThreeContainer: React.FC = () => {
  const list = [
    {
      id: SectionContentLinkListIdThree.ThingsToKeepInMind,
      text: sections.tabThreeSection.tab.contents.item1(),
    },
    {
      id: SectionContentLinkListIdThree.BFFProfileSharing,
      text: sections.tabThreeSection.tab.contents.item2(),
    },
  ];
  const props = {
    columnLeft: {
      title: sections.tabThreeSection.tab.title(),
      subTitle: sections.tabThreeSection.tab.text(),
    },
    columnRight: {
      title: sections.tabThreeSection.tab.contents.title(),
      content: <SectionContentLinkList list={list} />,
    },
    image: {
      src: `${CdnImagePath}/assets/tab-03/tab-03-01.jpg`,
      objectPosition: '50% 33%',
      inlinePosition: 'start',
    },
  };

  return <PageSectionTwoColumnsImageFullwidth {...props} />;
};
